import { render, staticRenderFns } from "./SimilarCollections.vue?vue&type=template&id=7e4b0ed7"
import script from "./SimilarCollections.vue?vue&type=script&lang=js"
export * from "./SimilarCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports